import { Card, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../app/stores/store'
import { currencyValue, formatCurrency } from '../muiStyle/muiStyle'
import { Tooltip } from '@mui/material'
import { formatToLocalDate } from '../../../app/helpers'
import EmailIcon from '@mui/icons-material/Email'

function AuctionBidCard() {
  const { bidsStore, userStore } = useStore()
  const { t, i18n } = useTranslation()

  const currencyName = currencyValue.find(
    (item) => item.value === bidsStore.auctionDetails?.post?.currency,
  )?.name
  console.log(i18n)
  return (
    <Card className='auction-details-bid-card'>
      <Card.Header>
        <div className='d-flex justify-content-between'>
          <h5>{t('auction_bidders')}: </h5>
          <p>
            {t('bids')}: {bidsStore.bids.length}
          </p>
        </div>
      </Card.Header>

      {bidsStore.bids.slice(0, 7).map((bid, index) => (
        <Card.Body
          key={bid.id}
          className={`d-flex position-relative ${index === 6 && 'auction-card-hide'}`}
        >
          <Image
            src={
              bid.avatarId
                ? bid.avatar
                : bid.gender === 1
                  ? '/images/avatar/avatar1.png'
                  : bid.gender === 0
                    ? '/images/avatar/avatar2.png'
                    : bid.gender === 2
                      ? '/images/avatar/avatar3.png'
                      : '/images/avatar/avatar1.png'
            }
            style={{ height: '80px', borderRadius: '50%' }}
            className='me-3'
          />
          <div className='auction-details-bid-card-body'>
            <Card.Title className='mb-1'>
              {bid.firstName ? `${bid.firstName} ${bid.lastName}` : 'John Doe'}
              {userStore.user?.id === bidsStore.auctionDetails?.post?.userId && (
                <a className='mx-2' href={`mailto:${bid.email}`}>
                  <Tooltip title={bid.email}>
                    <EmailIcon />
                  </Tooltip>
                </a>
              )}
            </Card.Title>
            <Card.Text className='mb-2' style={{ fontSize: '16px' }}>
              {formatToLocalDate(bid.createdAt, i18n.language)}
            </Card.Text>
            <Card.Text>
              {t('bidding_value')}: <strong>{`${currencyName} ${formatCurrency(bid.bid)}`}</strong>
            </Card.Text>
          </div>
        </Card.Body>
      ))}
    </Card>
  )
}
export default observer(AuctionBidCard)
